<div
  tabindex="-1"
  role="dialog"
  class="mm-container"
  [class.modern]="componentData?.buttonContainerStyle === 'modern'"
  [class.modern__logged-out-burger-menu]="componentData?.buttonContainerStyle === 'modern' && !isUserLoggedIn"
  (keyup.escape)="closed.emit()"
  cdkTrapFocusAutoCapture
  [cdkTrapFocus]="true"
>
  <div [ngClass]="{ 'site-selector': showSiteSelectorDropDown }" [class.no-site-selector]="isUserLoggedIn">
    <div
      role="button"
      *ngIf="!isUserLoggedIn && showSiteSelectorDropDown"
      mat-icon-button
      [attr.aria-labelledby]="'countrySelector'"
      id="mobile_country_selector"
      [disableRipple]="true"
      class="selected-site-button"
      cdk-overlay-origin
      #countryLanguageSelect="cdkOverlayOrigin"
      (click)="isCountrySelectVisible = !isCountrySelectVisible"
    >
      <ng-template
        cdk-connected-overlay
        cdkConnectedOverlayPanelClass="ten-country-selector__overlay"
        [cdkConnectedOverlayOrigin]="countryLanguageSelect"
        cdkConnectedOverlayHasBackdrop
        [cdkConnectedOverlayOpen]="isCountrySelectVisible"
        (backdropClick)="isCountrySelectVisible = false"
        [cdkConnectedOverlayPositions]="positionsCountrySelectMenu"
      >
        <div class="ten-country-selector__panel">
          <ten-country-selector
            [sites]="sites$"
            [init]="selectedSite"
            (emitSiteDetails)="updateSite($event)"
            (closed)="isCountrySelectVisible = false"
          ></ten-country-selector>
        </div>
      </ng-template>
      <mat-icon
        *ngIf="!showGlobeIcon"
        class="fi fi-{{ (selectedSite | async)?.display_country_code | lowercase }} fis"
      ></mat-icon>
      <mat-icon *ngIf="showGlobeIcon" class="globe-icon" fontIcon="language"></mat-icon>
      <span>{{ siteDisplayName }}</span>
      <mat-icon>arrow_drop_down</mat-icon>
    </div>
    <span tabindex="0" aria-label="Close" role="button" class="close-icon" (accessibleClick)="closed.emit()">
      <mat-icon>close</mat-icon>
    </span>
  </div>
  <ul
    class="mobile-menu"
    [class.priceless-donate-visible]="togglePriceless && isUserLoggedIn"
    [class.modern]="componentData?.buttonContainerStyle === 'modern'"
    [class.modern__logged-out-list]="componentData?.buttonContainerStyle === 'modern' && !isUserLoggedIn"
  >
    <ng-container *ngIf="siteSettingsLoaded && showFeatureNavLinks">
      <ng-container *ngFor="let menu of menuList; index as i">
        <li
          *ngIf="menu.isVisible"
          class="mobile-menu__item mobile-menu__item--full mat-headline"
          [class.mobile-menu__item--sub-navigation]="menu.hasSubNavigation"
          [class.mobile-menu__item--modern]="componentData?.buttonContainerStyle === 'modern'"
        >
          <a
            #routerLink="routerLinkActive"
            routerLinkActive="is-selected"
            href
            tabindex="0"
            role="link"
            class="mobile-menu__item__link"
            [attr.aria-label]="menu.ariaLabel"
            [routerLink]="menu.routerLink"
            [attr.aria-current]="routerLink.isActive"
            (accessibleClick)="navigate(menu.routerLink)"
          >
            {{ menu.customName || menu.translate | translate }}
          </a>
          <mat-icon
            *ngIf="subMenuList && menu.hasSubNavigation"
            tabindex="0"
            (accessibleClick)="subMenuList.active = !subMenuList.active"
            class="sub-menu__open"
          >
            {{ subMenuList.active ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}
          </mat-icon>
        </li>

        <div *ngIf="menu.hasSubNavigation && subMenuList" class="sub-menu__list" [class.active]="subMenuList.active">
          <span class="sub-menu__item lvl1 active" *ngFor="let menu of subMenuList.subpages">
            <div class="sub-menu__item-title">
              <a href="{{ menu.link }}" tabindex="0">{{ menu.name }}</a>
              <mat-icon
                *ngIf="menu?.subpages?.length"
                class="sub-menu__open"
                tabindex="0"
                (accessibleClick)="menu.active = !menu.active"
              >
                {{ menu.active ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}
              </mat-icon>
            </div>
            <span class="sub-menu__item lvl2" [class.active]="menu.active" *ngFor="let subMenu of menu?.subpages">
              <a href="{{ subMenu.link }}">{{ subMenu.name }}</a>
            </span>
          </span>
        </div>
      </ng-container>
      <li
        *ngIf="externalPortal?.link && externalPortal?.name"
        class="mobile-menu__item mobile-menu__item--external mobile-menu__item--full mat-headline"
        [class.mobile-menu__item--modern]="componentData?.buttonContainerStyle === 'modern'"
      >
        <a
          tabindex="0"
          role="link"
          class="mobile-menu__item__link"
          target="_blank"
          [href]="externalPortal?.link"
          [attr.aria-label]="'external portal'"
          (click)="clearSelectedTravelers()"
        >
          {{ externalPortal?.name | translate }}
          <mat-icon>launch</mat-icon>
        </a>
      </li>

      <ng-container *ngIf="(memberProfile$ | async)?.navigation_links">
        <li
          role="menuitem"
          class="mobile-menu__item mobile-menu__item--full mat-headline"
          [class.mobile-menu__item--modern]="componentData?.buttonContainerStyle === 'modern'"
          *ngFor="let link of (memberProfile$ | async)?.navigation_links"
        >
          <a tabindex="0" role="link" [href]="link.link" class="mobile-menu__item__link">{{ link.title }}</a>
        </li>
      </ng-container>

      <li
        class="mobile-menu__item mobile-menu__item--sep"
        [class.mobile-menu__item--modern]="componentData?.buttonContainerStyle === 'modern'"
      ></li>
    </ng-container>

    <li
      *ngIf="isUserLoggedIn"
      class="mobile-menu__item mobile-menu__item--full mat-headline"
      [class.mobile-menu__item--modern]="componentData?.buttonContainerStyle === 'modern'"
    >
      <a class="mobile-menu__item__link" role="link" tabindex="0" (accessibleClick)="logout.emit()">
        {{ 'GlobalNav:NavLogout' | translate }}
      </a>
    </li>

    <li
      *ngIf="!isUserLoggedIn && componentData.buttonContainerStyle === 'modern' && !HomepageContentOutside"
      class="mobile-menu__item mobile-menu__item--full mat-headline"
      [class.mobile-menu__item--modern]="componentData?.buttonContainerStyle === 'modern'"
    >
      <a
        class="mobile-menu__item__link"
        role="link"
        tabindex="0"
        (accessibleClick)="login.emit()"
        [innerHTML]="(variables$ | async).MTLS_PreLogin_Login"
      >
      </a>
    </li>

    <li
      *ngIf="
        !isUserLoggedIn && !HomepageContentOutside && componentData.buttonContainerStyle === 'modern' && showSelfReg
      "
      [class.mobile-menu__item--modern]="componentData?.buttonContainerStyle === 'modern'"
      class="mobile-menu__item mobile-menu__item--full mat-headline"
    >
      <a
        class="mobile-menu__item__link"
        role="link"
        tabindex="0"
        (accessibleClick)="register.emit()"
        [innerHTML]="(variables$ | async).MTLS_PreLogin_Register_Now"
      >
      </a>
    </li>

    <li
      *ngIf="!isUserLoggedIn && HomepageContentOutside"
      class="mobile-menu__item mobile-menu__item--full mat-headline mobile-menu__item--modern"
    >
      <a class="mobile-menu__item__link" role="link" tabindex="0" (accessibleClick)="login.emit()">
        {{ 'PreLoginCTA:Login' | translate }}
      </a>
    </li>

    <li
      *ngIf="!isUserLoggedIn && (showSelfReg || eligibilityType) && HomepageContentOutside"
      class="mobile-menu__item mobile-menu__item--full mat-headline mobile-menu__item--modern"
    >
      <a class="mobile-menu__item__link" role="link" tabindex="0" (accessibleClick)="register.emit()">
        {{ 'PreLoginCTA:RegisterNow' | translate }}
      </a>
    </li>

    <li
      class="mobile-menu__item mobile-menu__item--sep pb-2"
      [class.mobile-menu__item--modern]="componentData?.buttonContainerStyle === 'modern'"
    ></li>

    <ng-container *ngFor="let menu of secondaryMenuList$ | async">
      <li
        *ngIf="menu.isVisible && isUserLoggedIn"
        class="mobile-menu__item mobile-menu__item--small"
        [class.mobile-menu__item--modern]="componentData?.buttonContainerStyle === 'modern'"
      >
        <a
          href
          role="link"
          tabindex="0"
          class="mobile-menu__item__link"
          [routerLink]="menu.routerLink"
          (accessibleClick)="navigate(menu.routerLink)"
        >
          {{ menu?.customName ? menu?.customName : (menu.translate | translate) }}
        </a>
      </li>
    </ng-container>

    <ng-container *ngFor="let burgerMenu of burgerMenuList$ | async">
      <li
        *ngIf="
          burgerMenu.isVisible &&
          componentData?.buttonContainerStyle === 'modern' &&
          !HomepageContentOutside &&
          !isUserLoggedIn
        "
        class="mobile-menu__item mobile-menu__item--small"
        [class.mobile-menu__item--modern]="componentData?.buttonContainerStyle === 'modern'"
      >
        <a
          tabindex="0"
          class="mobile-menu__item__link"
          href="{{ burgerMenu?.routerLink }}"
          target="_blank"
          rel="noopener noreferrer"
          [innerHTML]="burgerMenu?.customName || (burgerMenu.translate | translate)"
        >
        </a>
      </li>
    </ng-container>

    <ng-container *ngFor="let burgerMenu of contentOutside$ | async">
      <li
        *ngIf="burgerMenu.isVisible && !isUserLoggedIn && HomepageContentOutside"
        class="mobile-menu__item mobile-menu__item--small modern"
      >
        <a
          tabindex="0"
          class="mobile-menu__item__link"
          (accessibleClick)="navigateTo(burgerMenu)"
          rel="noopener noreferrer"
          [innerHTML]="burgerMenu?.customName || (burgerMenu.translate | translate)"
        >
        </a>
      </li>
    </ng-container>

    <ng-container *ngIf="componentData.buttonContainerStyle === 'modern' && showPlatformProvider && !isUserLoggedIn">
      <div *ngIf="platformProviderType === 'provider' && isAccessHrt" class="platform-provider">
        <div class="platform-provider__text" [translate]="'GlobalNav:ServiceProvidedBy'">Service provided by</div>
        <div
          role="img"
          class="platform-provider__icon"
          [attr.aria-label]="'GlobalNav:ServiceProvidedBy' | translate"
        ></div>
      </div>

      <div *ngIf="platformProviderType === 'delivered'" class="platform-provider">
        <div class="platform-provider__text" [translate]="'GlobalNav:DeliveredBy'">Delivered by Ten</div>
      </div>

      <div *ngIf="platformProviderType === 'partnership'" class="platform-provider">
        <div class="platform-provider__text" [translate]="'GlobalNav:InPartnerShipWith'">In partnership with</div>
        <div
          role="img"
          class="platform-provider__icon"
          [attr.aria-label]="'GlobalNav:ServiceProvidedBy' | translate"
        ></div>
      </div>
    </ng-container>
  </ul>

  <div *ngIf="togglePriceless && isUserLoggedIn" class="priceless-mobile-menu-wrapper">
    <div *ngIf="togglePriceless && isUserLoggedIn" class="priceless-mobile-menu" tabindex="0">
      <p>{{ (variables$ | async)?.priceless_menu_text }}</p>
      <mtls-priceless-button text="{{ 'PricelessPlanetCTA:DonateNow' | translate }}"></mtls-priceless-button>
    </div>
  </div>
</div>
